<template>
  <div class="vue-tempalte">
    <nav class="navbar sticky-top navbar-fixed-top navbar-expand-md navbar-light navbar-laravel navbar-second" style="background-color: #fff" v-bind:class=" { 'navbarOpen': show }">
      <div class="container position-relative">
        <router-link class="navbar-brand" to="/">
          <img src="./assets/images/city-jungle-logo.png" alt="" style="max-width:150px;">
        </router-link>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation" @click.stop="toggleNavbar()">
          <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" v-bind:class="{ 'show': show }" id="navbarSupportedContent">
          <!-- Left Side Of Navbar -->
          <ul class="navbar-nav mr-auto" >
            <li class="nav-item" @click.stop="toggleNavbar()" ><router-link class="nav-link" to="/">Начало</router-link></li>
            <li class="nav-item" @click.stop="toggleNavbar()" ><router-link class="nav-link" to="/team">За нас</router-link></li>
            <li class="nav-item" @click.stop="toggleNavbar()" ><router-link class="nav-link" to="/services">Услуги</router-link></li>
            <!--<li class="nav-item" @click.stop="toggleNavbar()" ><router-link class="nav-link" to="/grooming">Груминг салон</router-link></li>-->
            <li class="nav-item" @click.stop="toggleNavbar()" ><router-link class="nav-link" to="/news">Новини</router-link></li>
            <li class="nav-item" @click.stop="toggleNavbar()" ><router-link class="nav-link" to="/interesting">Интересни случаи</router-link></li>
            <li class="nav-item" @click.stop="toggleNavbar()" ><router-link class="nav-link" to="/tips">Полезни съвети</router-link></li>
            <li class="nav-item" @click.stop="toggleNavbar()" ><router-link class="nav-link" to="/prices">Цени</router-link></li>
            <li class="nav-item" @click.stop="toggleNavbar()" ><router-link class="nav-link" to="/gallery">Галерия</router-link></li>
            <li class="nav-item" @click.stop="toggleNavbar()" ><router-link class="nav-link" to="/contacts">Контакти</router-link></li>
          </ul>

          <!-- Right Side Of Navbar -->
          <ul class="navbar-nav ml-auto">
            <li v-if="userLogedIn" class="nav-item" @click="logOut()"><span class="nav-link ">Изход</span></li>
          </ul>
        </div>
      </div>
    </nav>
    <nav v-if="userLogedIn" class="navbar navbar-expand-md navbar-light navbar-laravel navbar-second" style="background-color: #fff">
      <div class="container position-relative">
        <router-link class="d-none navbar-brand" to="/">
          <p>Администрация</p>
        </router-link>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent2" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="navbarSupportedContent2">
          <!-- Left Side Of Navbar -->
          <ul class="navbar-nav mr-auto">
            <li><router-link class="nav-link" to="/team/create">Добави член на екип</router-link></li>
            <li><router-link class="nav-link" to="/services/create">Добави услуги</router-link></li>
            <li><router-link class="nav-link" to="/news/create">Добави новини</router-link></li>
            <li><router-link class="nav-link" to="/interesting/create">Добави интересни случаи</router-link></li>
            <li><router-link class="nav-link" to="/tips/create">Добави полезен съвет</router-link></li>

          </ul>
        </div>
      </div>
    </nav>
    <div class="fixed-menu">

      <div class="call-us">
        <a href="tel:0889 392029">
          <i class="fa fa-phone"></i>
        </a>
      </div>
      <div class="contact-us">
        <a href="https://maps.app.goo.gl/hyNVcU2diQe2RT4TA" target="_blank">
          <i class="fa fa-map-marker"></i>
        </a>
      </div>
    </div>
    <!-- Main -->
    <div class="App">
      <div>
        <router-view />
      </div>
    </div>
    <div class="footer">
      <div class="container">
        <div class="row">
          <div class="col-md-3">
            <h4>Свържете се с нас</h4>
            <div class="sec d-inline-block" style="margin-right: 50px;">
              <div class="icon d-inline-block">
                <i class="fa fa-mobile" aria-hidden="true"></i>
              </div>
              <div class="text d-inline-block">
                <h6><b>Контакти:</b></h6>
                <a href="tel:0889392029">0889 392 029</a><br>
                <a href="tel:024167404">02 416 7404</a>
              </div>
              <div class="clearfix"></div>
            </div>
            <div class="sec d-inline-block" style="margin-right: 50px;">
              <div class="icon d-inline-block">
                <i class="fa fa-map-marker" aria-hidden="true"></i>
              </div>
              <div class="text d-inline-block" style="max-width: 110px;">
                <h6><b>Адрес</b></h6>
                <p>София, ж.к. Дружба 2, ул.Обиколна, бл.616</p>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <h4>Бързи връзки</h4>
            <ul class="nav" style="display: block;">
              <li><router-link class="nav-link" to="/">Начало</router-link></li>
              <li><router-link class="nav-link" to="/team">За нас</router-link></li>
              <li><router-link class="nav-link" to="/news">Новини</router-link></li>
              <!--<li><router-link class="nav-link" to="/grooming">Груминг салон</router-link></li>-->
              <li><router-link class="nav-link" to="/interesting">Интересни случаи</router-link></li>
              <li><router-link class="nav-link" to="/gallery">Галерия</router-link></li>
              <li><router-link class="nav-link" to="/contacts">Контакти</router-link></li>
            </ul>
          </div>
          <div class="col-md-3">
            <h4>Нашите услуги</h4>
            <ul class="nav">
              <li><router-link class="nav-link" to="/services">Списък с услуги</router-link></li>
              <li><router-link class="nav-link" to="/prices">Цени на услугите</router-link></li>
            </ul>
          </div>
          <div class="col-md-3">
            <h4>Последвайте ни</h4>
            <div class="footer-menu row">
              <ul class="nav">
                <li><a class="nav-link" target="_blank" href="https://www.facebook.com/133554236672367"><i class="fa fa-facebook"></i></a></li>
                <li><a class="nav-link" target="_blank" href="https://www.instagram.com/cityjungle/"> <i class="fa fa-instagram"></i></a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="rights text-center">
      <div class="container">
        <div class="col-md-12">
          <p>Всички права запазени</p>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
  export default {
    data() {
      return {
        show: false
      }
    },
    computed: {
      userLogedIn () {
        return this.$store.getters.user
      }
    },
    methods: {
      toggleNavbar() {
        this.show = !this.show;
      },
      logOut() {
        this.$store.dispatch('signOutAction').then(() => {
          this.$router.push('/')
        }).catch((error) => {
          alert(error.message);
        });
      }
    },
  }
</script>
<style>
  [class*="navbarOpen"] {
    transition: all 1s;
  }
  .navbar-collapse {
    transition: all 1s;
  }
  .color-red {
    color: red;
  }
</style>
